// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__FBGG1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__3BZn5"};